import state from './state'
import axios from 'axios'
import { promiseWp } from '../../comm/js/promiseExt'
import { mergeAnalysisResume } from '../../modules/personal/js/commonFunction.js'
export default {
  state,
  mutations: {
    setResumePageScrollTop(state, top) {
        state.resumePageScrollTop = top
    },
    setResumeInfo(state, resume) {
        state.resumeInfo = resume;
    },
    setRefreshResumeFlag(state, flag) {
      state.refreshResumeFlag = flag;
    },
    setAnalysisResume(state, resume) {
      state.analysisResume = resume;
    },
    // 更新个人简历内容
    updateMyResume(state, resume) {
      state.myResumeInfo = resume
    },
    // 更新新鹰计划标识
    setResumeEagleFlag(state, flag) {
      state.resumeEagleFlag = flag
    }
  },
  actions: {
    // 更新个人简历内容
    async updateResume({
      commit,
      state
    }) {
      const isEagle = {};
      if (state.resumeEagleFlag) {
        isEagle.type = "eagle";
      }
      //获取自己简历信息
      const res = await axios.get(`web/resume/my`, { params: { ...isEagle, time: new Date().getTime() } })

      // 保存简历数据
      // this.setRefreshResumeFlag(false);
      commit('updateMyResume', res || {})
      commit('setResumeInfo', res || {})
    },
    // 更新解析出简历
    async updateAnalysisResume({
      state,
      dispatch
    }, params) {
      const [ res, err ] = await promiseWp(axios.post(`web/resume/parse${state.resumeEagleFlag ? '?type=eagle' : ''}`, params))

      res && dispatch('applyAnalysisResume', res)

      return [ res, err ]
    },

    applyAnalysisResume({
      commit,
      state
    }, analysisResume) {
      const mergedResume = mergeAnalysisResume(state.resumeInfo, analysisResume)

      commit('setAnalysisResume', mergedResume)
      commit('setResumeInfo', mergedResume)

      return mergedResume
    },
    // 提交简历
    async submitResume({
      commit,
      state
    }, resume) {
      const resumeId =  resume.id
      const url = resumeId? `web/resume/update/${resumeId}`: `web/resume/add`
      const method = resumeId? 'put': 'post'

      // 如果是新鹰计划 需要另外传参数
      resume.eagelFlag = !!state.resumeEagleFlag
      resume.fromMobile = resumeId ? 0 : 1;

      const [ res, err ] = await promiseWp(axios[method](url, resume, { customError: true }))

      if(res) {
        commit('setResumeInfo', null);
        commit('setAnalysisResume', null);
      }

      return [ res, err ]
    },
    // 合并简历
    async resetUserInfo({
      commit
    }, params) {
      const [ res, err ] = await promiseWp(axios.get(`/web/index/resetUserInfo`, {params}))

      if(res) {
        commit('setResumeInfo', null);
        commit('setAnalysisResume', null);
      }

      return [ res, err ]

    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/resume/index.js